import { useState } from "react";
import { HttpService } from "../../services/HttpService";
import ButtonWhite from "../common/buttonWhite";
import {
  updateEventId,
  updateNamePharmacy,
} from "../../redux/reducer/LoginReducer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getNavigationPath } from "../../utils/helpers";

const BoxNullItems = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [error, setError] = useState("");
  const dispacth = useDispatch();
  const { user } = useSelector((state: any) => state.login);

  const eventInit = async () => {
    try {
      setSpinner(true);

      let result = await HttpService.post(
        `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/event-init`,
        {}
      );

      dispacth(updateEventId(result.data.eventId));
      dispacth(updateNamePharmacy(result.data.eventName));
      // get navigation path base on user modules
      const path = getNavigationPath(user);
      navigate(path);
    } catch (error) {
      setSpinner(false);
      console.log(error);
      setError(t("error.event-init"));
    }
  };

  const label = props.label ?? "";
  const icon = props.icon ?? "";
  const buttonLabel = props.buttonLabel ?? "";
  return (
    <div className="col-lg-4 mx-auto  text-center">
      <div className="BoxNullItems">
        <span className="material-symbols-outlined">{icon}</span>
        <h4 className="mb-3">{label}</h4>
        {buttonLabel && (
          <ButtonWhite
            spinner={spinner}
            textButton={buttonLabel}
            handleChange={eventInit}
          />
        )}
      </div>

      {error && <div className="text-danger text-center mt-3">{error}</div>}
    </div>
  );
};

export default BoxNullItems;
